import styled from 'styled-components';

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Container = styled.form`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;

export const ContainerMessage = styled.div`
  display: flex;
  gap: 10px;
`;

export const ContainerInsert = styled.div`
  display: flex;
  padding-top: 20px;
  flex-direction: column;
  margin-right: 7%;
  gap: 30px;
`;
export const ContainerButton = styled.div`
  margin-left: -7%;
`;

export const InfoText = styled.span`
  padding: 7px;
  margin-top: 7%;
  text-align: center;
  font-size: 1.4rem;
`;
